import { render, staticRenderFns } from "./WareHouseManage.vue?vue&type=template&id=547e56cf&scoped=true&"
import script from "./WareHouseManage.vue?vue&type=script&lang=js&"
export * from "./WareHouseManage.vue?vue&type=script&lang=js&"
import style0 from "./WareHouseManage.vue?vue&type=style&index=0&id=547e56cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e56cf",
  null
  
)

export default component.exports